/**
 * Catalog 的相关配置
 * 使用到商品库内容在这管理(DPA、Shop.)
 */

/** 字段类型 */
export const FieldTypes = {
  Int64: 0,
  Float: 1,
  String: 2,
};

export const BindTypes = {
  /** 交集 */
  Inter: 0,
  /** 并集 */
  Union: 1,
};

/** 大小写是否敏感 */
export const SensTypes = {
  /** 完全匹配 */
  Default: 0,
  /** 不区分大小写 */
  CaseInsensitive: 1,
};

/** 查询操作符 */
export const Operators = {
  Eq: 0,
  Ne: 1,
  Gt: 2,
  Gte: 3,
  Lt: 4,
  Lte: 5,
  Rng: 6,
  Wildcard: 7,
  Prefix: 8,
  Exist: 9,
  In: 10,
};

/** 商品上下架状态 */
export const ActiveStatus = {
  Active: '0',
  Inactive: '1',
  // 后台条件中只有 0 和 1
  // 2 是前端自己加的用来标识的值
  // 在请求之前需要过滤掉
  All: '2',
};

/** 查询的 SPU 的BI审核状态 */
export const SpuScope = {
  All: 0,
  Approve: 1,
  Reject: 2,
  Pending: 3,
};

/** 查询的 SPU 的GNE审核状态 */
export const SpuOrganicAuditStatus = {
  Init: 0,
  Approve: 1,
  Reject: 2,
  PartlyReject: 4,
};

/** 查询的 SPU 的BI上下线状态 */
export const SpuStatus = {
  Init: -1,
  Offline: 0,
  Online: 1,
  Deleted: 120,
};

/** 查询的 SPU 的GNE上下线状态 */
export const SpuOrganicStatus = {
  Offline: 0,
  Online: 1,
  Init: 110,
  Deleted: 120,
};

/**
 * 商品字段及类型
 */
export const Fields = {
  title: {
    fieldName: 'title',
    fieldType: FieldTypes.String,
    sensType: SensTypes.CaseInsensitive,
  },
  OuterID: {
    fieldName: 'OuterID',
    fieldType: FieldTypes.String,
    sensType: SensTypes.CaseInsensitive,
  },
  spuID: {
    fieldName: 'spuID',
    fieldType: FieldTypes.String,
    sensType: SensTypes.CaseInsensitive,
  },
  activeStatus: {
    fieldName: 'activeStatus',
    fieldType: FieldTypes.String,
    sensType: SensTypes.Default,
  },
  storefrontStatus: {
    fieldName: 'storefront_status',
    fieldType: FieldTypes.Int64,
    sensType: SensTypes.Default,
  },
};

/**
 * 商品搜索中可以使用的字段
 */
export const getSearchFields = hidden => [
  {
    fieldName: Fields.OuterID.fieldName,
    fieldType: Fields.OuterID.fieldType,
    sensType: Fields.OuterID.sensType,
    label: 'module_catalog_search_by_skuid',
    hidden,
  },
  {
    fieldName: Fields.spuID.fieldName,
    fieldType: Fields.spuID.fieldType,
    sensType: Fields.spuID.sensType,
    label: 'module_catalog_search_by_spuid',
  },
  {
    fieldName: Fields.title.fieldName,
    fieldType: Fields.title.fieldType,
    sensType: Fields.title.sensType,
    label: 'module_catalog_search_by_title',
  },
].filter(item => !item.hidden);
